import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';

interface ListEditButtonsProps {
  onEdit: () => void;
  isReadOnly?: boolean;
}

const ListEditButton = ({ onEdit, isReadOnly }: ListEditButtonsProps) => {
  const onClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onEdit();
  };

  return (
    <Box>
      <IconButton onClick={onClick} disabled={isReadOnly}>
        <EditIcon color={isReadOnly ? 'disabled' : 'primary'} />
      </IconButton>
    </Box>
  );
};

export default ListEditButton;
